<template>
  <div class="overlay" :class="{ visible: props.visible }">
    <div class="screen-dim" :class="{ visible: props.visible }"></div>
    <div v-if="props.visible" class="content">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
/*
   OverlayScreen component provides "Overlay Screen"
   - visible: true means shows overlay and "slot".
   - <slot>: content in overlay.
*/
import { watch } from 'vue'

const props = defineProps<{
  visible: boolean
}>()

const body = document.querySelector('body')!

watch(
  () => props.visible,
  (visible) => {
    body.style.overflowY = visible ? 'hidden' : 'auto'
  }
)
</script>

<style scoped>
.overlay {
  position: fixed;
  top: 0px;
  width: 100%;
  height: 100%;
  pointer-events: none;
}
.overlay.visible {
  pointer-events: auto;
}

.screen-dim {
  background: radial-gradient(#fff 30%, #000 100%);
  opacity: 0;
  width: 100%;
  height: 100%;
  transition: all 0.5s ease-in-out 0s;
}

.screen-dim.visible {
  opacity: 0.3;
}

.content {
  position: absolute;
  top: 0px;
  width: 100%;
  height: 100%;
}
</style>
